import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getQuestions({ commit }, code) {
      try {
        const response = await api.get(`/forms/${code}/questions`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async createAnswers({ commit }, data) {
      try {
        return await api.post(`/forms/${data.code}/answers`, data.answers)
      } catch (error) {
        throw error
      }
    },

    async getAnswers({ commit }, data) {
      try {
        const response = await api.get(
          `/forms/${data.code}/answers?userId=${data.filters.userId}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
